import { render, staticRenderFns } from "./InstantPix.vue?vue&type=template&id=64a70266"
import script from "./InstantPix.vue?vue&type=script&lang=js"
export * from "./InstantPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports